<template>
  <v-container class="pa-0">
    <RiskCategoriesPicker
      :reset="reset"
      :risk-categories-filter-counts="riskCategoriesFilterCounts"
      :selected-risk-categories="selectedRiskCategories"
      @change="handleChangeRiskCategories"
    ></RiskCategoriesPicker>
  </v-container>
</template>

<script>
const EMITTED_ACTIONS = {
  CHANGE_RISK_CATEGORIES: "change-risk-categories",
  CHANGE_HAS_RISK_CATEGORIES_SELECTED: "change-has-risk-categories-selected",
};

export default {
  name: "SearchFilterAnalysis",
  components: {
    RiskCategoriesPicker: () =>
      import("@/components/riskCategories/RiskCategoriesPicker"),
  },
  props: {
    reset: {
      type: String,
    },
    riskCategoriesFilterCounts: {
      type: Object,
    },
    riskCategoriesSelection: {
      type: String,
    },
  },
  data() {
    return {
      selectedRiskCategories: null,
    };
  },
  methods: {
    handleChangeRiskCategories(params) {
      this.selectedRiskCategories = params.riskCategories;
      this.$emit(EMITTED_ACTIONS.CHANGE_RISK_CATEGORIES, params.riskCategories);
      const selected = this.selectedRiskCategories
        ? this.selectedRiskCategories.split(",").length > 0
        : false;
      this.$emit(EMITTED_ACTIONS.CHANGE_HAS_RISK_CATEGORIES_SELECTED, selected);
    },
  },
  watch: {
    riskCategoriesSelection: {
      handler() {
        this.selectedRiskCategories = this.riskCategoriesSelection;
        this.$emit(
          EMITTED_ACTIONS.CHANGE_HAS_RISK_CATEGORIES_SELECTED,
          this.selectedRiskCategories
        );
      },
    },
    reset: {
      handler() {
        this.selectedRiskCategories = null;
        this.$emit(
          EMITTED_ACTIONS.CHANGE_HAS_RISK_CATEGORIES_SELECTED,
          this.selectedRiskCategories
        );
      },
    },
  },
  beforeDestroy() {
    this.selectedRiskCategories = null;
  },
};
</script>

<style scoped></style>
